module.exports = __webpack_public_path__ + "img/3.a27e0dc9.svg";